// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + {"476":"veranstaltungen","594":"about","596":"gruppen","665":"kontakt"}[chunkId] + "." + {"476":"284dd1cb","594":"20e9da92","596":"cc7be42b","665":"42f9b0c8"}[chunkId] + ".js";
};